import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/rootReducer";
import logger from "redux-logger";

const store = createStore(
  rootReducer,
  compose(applyMiddleware(logger))
);


export default store;
